/**
 * Elevation for the floating bottom search/action surface and the add button
 * that sits beside it, so the two stay visually matched.
 */
export const BOTTOM_BAR_SHADOW = '0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.04)';
export const BOTTOM_BAR_STRONG_SHADOW = '0 2px 6px rgba(0, 0, 0, 0.08), 0 8px 18px rgba(0, 0, 0, 0.08)';
export const BOTTOM_BAR_STRONG_FOCUS_SHADOW = '0 3px 8px rgba(0, 0, 0, 0.09), 0 10px 24px rgba(0, 0, 0, 0.1)';

/**
 * Lift for a large field sitting on a tinted ground. Far lighter than Chakra's `xs`, whose second
 * layer is a 20% hairline that reads as a drawn edge at this size; the negative spread keeps the
 * blur off the sides.
 */
export const FIELD_SURFACE_SHADOW = '0 3px 6px -2px rgba(0, 0, 0, 0.02), 0 1px 1px rgba(0, 0, 0, 0.04)';

// Light separation for compact white controls sitting on surface.canvas.
export const CONTROL_SURFACE_SHADOW = 'xs';

/**
 * Chakra shadow tokens have failed to render on some older mobile browsers for
 * segmented-control indicators. Use a raw base value there while keeping the
 * desktop token.
 */
export const SEGMENTED_CONTROL_INDICATOR_SHADOW = {
	base: '0 2px 4px rgba(24, 24, 27, 0.1), 0 0 1px rgba(24, 24, 27, 0.3)',
	md: 'sm',
} as const;
